import { useContext } from "react";
import { useMediaQuery, useTheme } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import { PlannerContext } from "../../context/planner/PlannerContext";

const TimeMarker = ({
  time,
  isGap = false,
  isEnd = false,
  isEmptySlot = false,
  isBlockStart = false,
  gapDuration = 0,
  slotDuration = 0,
  isPast = false,
}) => {
  const { setSelectedTool, setActiveTime, activeTime, openToolPanel } =
    useContext(PlannerContext);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const onAddClick = () => {
    setActiveTime(time);
    setSelectedTool("insertBlock");
    if (isMobile) {
      openToolPanel("insertBlock");
    }
  };

  // Format duration for display
  const formatDuration = (minutes) => {
    if (minutes >= 60) {
      const hours = Math.floor(minutes / 60);
      const mins = minutes % 60;
      return mins > 0 ? `${hours}h ${mins}m` : `${hours}h`;
    }
    return `${minutes}m`;
  };

  const pastClass = isPast ? "time-marker--past" : "";

  if (activeTime === time) {
    return (
      <div className="wip-box">
        <span className="wip-label">Adding new block</span>
      </div>
    );
  }

  // End marker - no add button
  if (isEnd) {
    return (
      <div className={`time-marker time-marker--end ${pastClass}`}>
        <span className="time-marker_label">{time}</span>
        <div className="time-marker_line" />
      </div>
    );
  }

  // Block start marker - no add button
  if (isBlockStart) {
    return (
      <div className={`time-marker time-marker--block-start ${pastClass}`}>
        <span className="time-marker_label">{time}</span>
        <div className="time-marker_line" />
      </div>
    );
  }

  // Empty slot marker - shows as clickable slot to add a block
  if (isEmptySlot) {
    return (
      <div
        className={`time-marker time-marker--empty-slot ${pastClass} ${!isPast ? "time-marker--clickable" : ""}`}
        onClick={!isPast ? onAddClick : undefined}
        title={!isPast ? "Add block" : undefined}
      >
        <span className="time-marker_label">{time}</span>
        <div className="time-marker_line" />
        {!isPast && (
          <>
            <AddIcon
              className="time-marker_add-inline-icon time-marker_add-inline-icon--slot"
              fontSize="small"
            />
            <div className="time-marker_line" />
          </>
        )}
      </div>
    );
  }

  // Gap marker with duration display (legacy support)
  if (isGap && gapDuration > 0) {
    return (
      <div
        className={`time-marker time-marker--gap ${pastClass} ${!isPast ? "time-marker--clickable" : ""}`}
        onClick={!isPast ? onAddClick : undefined}
        title={
          !isPast
            ? `Add block (${formatDuration(gapDuration)} available)`
            : undefined
        }
      >
        <span className="time-marker_label">{time}</span>
        <div className="time-marker_line" />
        {!isPast && (
          <>
            <AddIcon
              className="time-marker_add-inline-icon time-marker_add-inline-icon--gap"
              fontSize="small"
            />
            <div className="time-marker_line" />
          </>
        )}
      </div>
    );
  }

  return (
    <div
      className={`time-marker ${pastClass} ${!isPast ? "time-marker--clickable" : ""}`}
      onClick={!isPast ? onAddClick : undefined}
      title={!isPast ? "Add block" : undefined}
    >
      <span className="time-marker_label">{time}</span>
      <div className="time-marker_line" />
      {!isPast && (
        <>
          <AddIcon className="time-marker_add-inline-icon" fontSize="small" />
          <div className="time-marker_line" />
        </>
      )}
    </div>
  );
};

export default TimeMarker;
